import { __awaiter } from "tslib";
import { ScheduleCitationService } from "@/services/models/schedule/scheduleCitation";
import moment from "moment";
const moduleScheduleCitation = {
    namespaced: true,
    state: {
        scheduleCitationFilter: [],
        dataFilter: {
            service_node_id: null,
            consultant_id: null,
            name: null,
            user_id: null,
        },
        scheduleCitationProfessionalFilter: {
            data: [],
            total: 0,
            per_page: 15,
            current_page: 1,
        },
        dataFilterPatientCitation: {
            professional_id: null,
            state: null,
            date: null,
            name: null,
            schedule_id: null,
            node_id: null,
            is_unscheduled: null,
        },
        loading: false,
        scheduleCitation: null,
    },
    getters: {
        getScheduleCitationfilter(state) {
            return state.scheduleCitationFilter;
        },
        getDataFilter(state) {
            return state.dataFilter;
        },
        getScheduleCitationProfessionalFilter(state) {
            state.scheduleCitationProfessionalFilter.data = state.scheduleCitationProfessionalFilter.data.sort((a, b) => {
                const timeStart = moment(a.schedule_detail.time_start, "hh:mm");
                const timeEnd = moment(b.schedule_detail.time_start, "hh:mm");
                const diffTime = timeStart.diff(timeEnd);
                //Si la diferencia es 0 significa que tienen la misma hora y una debe ser sobrecupo
                if (diffTime == 0) {
                    //Al ser iguales se ordenan según id, quedando última el último cupo agregado, el cual siempre será el sobrecupo
                    if (a.id > b.id) {
                        return 1;
                    }
                    else {
                        return -1;
                    }
                }
                else {
                    return diffTime;
                }
            });
            return state.scheduleCitationProfessionalFilter;
        },
        getDataFilterProfessional(state) {
            return state.dataFilterPatientCitation;
        },
        getLoading(state) {
            return state.loading;
        },
    },
    mutations: {
        setScheduleCitationFilter(state, scheduleCitationFilter) {
            state.scheduleCitationFilter = scheduleCitationFilter;
        },
        setDataFilter(state, dataFilter) {
            state.dataFilter = dataFilter;
        },
        setScheduleCitationProfessionalFilter(state, scheduleCitationProfessionalFilter) {
            state.scheduleCitationProfessionalFilter = scheduleCitationProfessionalFilter;
        },
        cleanScheduleCitationProfessionalFilter(state, scheduleCitations) {
            state.scheduleCitationProfessionalFilter.data = scheduleCitations;
        },
        /***
         *
         *
         *
         */
        //Tuve que separar los sets, dado que se ocupa el mismo filtro en varios lados, de repente habian nulos, y como se recibia como objetos, no iltraba bien
        setDataFilterProfessional(state, dataFilterPatientCitation) {
            state.dataFilterPatientCitation = dataFilterPatientCitation;
        },
        setDataFilterPatientCitationProfessionalId(state, professional_id) {
            state.dataFilterPatientCitation.professional_id = professional_id;
        },
        setDataFilterPatientCitationState(state, stateScheduleCitation) {
            state.dataFilterPatientCitation.state = stateScheduleCitation;
        },
        setDataFilterPatientCitationIsUnscheduled(state, is_unscheduled) {
            state.dataFilterPatientCitation.is_unscheduled = is_unscheduled;
        },
        setDataFilterPatientCitationDate(state, date) {
            state.dataFilterPatientCitation.date = date;
        },
        setDataFilterPatientCitationName(state, name) {
            state.dataFilterPatientCitation.name = name;
        },
        setDataFilterPatientCitationScheduleId(state, schedule_id) {
            state.dataFilterPatientCitation.schedule_id = schedule_id;
        },
        setDataFilterPatientCitationNodeId(state, nodeId) {
            state.dataFilterPatientCitation.node_id = nodeId;
        },
        /***
         * FIN
         *
         *
         */
        setScheduleCitationProfessionalPaginated(state, page) {
            state.scheduleCitationProfessionalFilter.current_page = page;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        selectEveryScheduleCitation(state) {
            state.scheduleCitationProfessionalFilter.data = state.scheduleCitationProfessionalFilter.data.map((scheduleCitation) => {
                scheduleCitation.is_checked = true;
                return scheduleCitation;
            });
        },
    },
    actions: {
        getScheduleCitation({ commit, state }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const SCHEDULECITATION = yield ScheduleCitationService.getByReportCitation(state.dataFilter);
                commit("setScheduleCitationFilter", SCHEDULECITATION);
                commit("setLoading", false);
            });
        },
        getScheduleCitationProfessionalFilter({ commit, state }, options = { dontLoad: false, showGroup: false }) {
            return __awaiter(this, void 0, void 0, function* () {
                //Validar que dataFilterPatientCitation
                if (areAllKeysEmptyOrNull(state.dataFilterPatientCitation)) {
                    return;
                }
                console.log("options", options);
                if (!options.dontLoad) {
                    commit("setLoading", true);
                }
                const SCHEDULECITATION = yield ScheduleCitationService.getByProfessional(Object.assign(Object.assign({}, state.dataFilterPatientCitation), { show_group: options.showGroup }), state.scheduleCitationProfessionalFilter.current_page);
                commit("setScheduleCitationProfessionalFilter", SCHEDULECITATION);
                if (!options.dontLoad) {
                    commit("setLoading", false);
                }
            });
        },
    },
};
function areAllKeysEmptyOrNull(obj) {
    for (var key in obj) {
        if (obj[key] !== null && obj[key] !== undefined && obj[key] !== "") {
            return false; // If any key has a non-empty or non-null value, return false
        }
    }
    return true; // If all keys are either empty or null, return true
}
export default moduleScheduleCitation;
